import React from 'react';

function SectionLine() {
  return (
    <div
      className="mt-2 mb-3"
      style={ {
        margin: '0 auto', width: '90vw', height: '0.5px', border: '0.5px solid #ced4da',
      } }
    />
  );
}

export default SectionLine;
